// prettier-ignore
import { Component, OnInit, EventEmitter, ViewChild, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DatosFacturacionCaja, BuscaTramite, PersonaClientes,
   ServiciosConsultasInput, FacturacionData, CatMedioPagos, CatCfdiUsos, 
   AuxJasper, ParametroJasper, EnviarCorreo, InfoTramiteInput, ServiciosCalculos, 
   ServiciosCalculosTotales, ServiciosConsultas, Solicitudes } from '../../entidades/entidades';
import { Observable, from } from 'rxjs';
import { MuestraMensaje } from '../../shared/utilerias/notificaciones/notificaciones.component';
import { json_in, MedioPagos } from '../../entidades/entidades';
import { RegistraPagosService } from '../../servicios/registra-pagos.service';
import { DatosCfdiFacturasService } from '../../servicios/datos-cfdi-facturas.service';
import { CatMedioPagosService } from '../../servicios/cat-medio-pagos.service';
import { BuscaDetalleSolicitud, BuscaDetalleSolicitudInput } from '../../entidades/entidades';
import { BuscaDetalleSolicitudService } from '../../servicios/busca-detalle-solicitud.service';
import { BuscaDetalleSolicitudComponent } from '../../componentes/busca-detalle-solicitud/busca-detalle-solicitud.component';
import { MedioPagosComponent } from '../../componentes/medio-pagos/medio-pagos.component';
import { CatCfdiUsosGridComponent } from '../../componentes/cat-cfdi-usos-grid/cat-cfdi-usos-grid.component';
import { CatCfdiUsosService } from 'app/servicios/cat-cfdi-usos.service';
import { PersonaClientesService } from '../../servicios/persona-clientes.service';
import { JasperService } from 'app/servicios/jasper.service';
import { Router } from '@angular/router';
import { SolicitudDetallesGridComponent } from '../../componentes/solicitud-detalles-grid/solicitud-detalles-grid.component';
import { ServiciosConsultasService } from "../../servicios/servicios-consultas.service";
import { SolicitudesService } from "../../servicios/solicitudes.service";
import { ConfirmationService } from 'primeng/api';

import { saveAs } from 'file-saver';
import { TicketService } from 'app/servicios/ticket.service';
import { DatosFacturacionCajaComponent } from '../datos-facturacion-caja/datos-facturacion-caja.component';
import { EnviarCorreoService } from 'app/servicios/enviar-correo.service';

declare var $: any;

@Component({
  selector: 'app-caja-servicios',
  templateUrl: './caja-servicios.component.html',
  styleUrls: ['./caja-servicios.component.css']
})
export class CajaServiciosComponent implements OnInit {
  @Input("solicitudInput") solicitudInput: BuscaTramite;
  CajaForm: FormGroup;

  public datosFacturacion = new DatosFacturacionCaja();
  public datosFacturacionCaja$ = new EventEmitter<DatosFacturacionCaja>();
  public buscaDetalleSolicitud$: Observable<BuscaDetalleSolicitud>;
  public buscaDetalleSolicitudInput$ = new EventEmitter<BuscaDetalleSolicitudInput>();
  public buscaDetalleSolicitud: BuscaDetalleSolicitud;

  public mediosPagoInput$ = new EventEmitter<MedioPagos>();
  serviciosCalculosTotales: ServiciosCalculosTotales;

  personaCliente = new PersonaClientes();
  public medioPagos: MedioPagos;
  public usoCfdi: CatCfdiUsos;
  mediosPagosRecibidos: any[]=[];
  public total: number;
  public diferencia: number;
  public totalMedio: number = 0;
  public totalMedioRecibido: number = 0;
  public listoPagar: boolean;
  public pago: boolean = false;
  public Etiqueta = 'DIFERENCIA';
  public idAgua: number;
  public idAguaSolicitante: number = null ;
  public estadoTramite: string;
  public estatusPagos: string;
  public PropietarioAguas: any;
  usuario: any;
  facturacionData: FacturacionData;
  _id_factura: number;
  public enviaCorreo = new EnviarCorreo();
  public datosenviarCorreo$ = new EventEmitter<EnviarCorreo>();
  public infoTramiteInput$ = new EventEmitter<InfoTramiteInput>();
  public medioP$ = new EventEmitter<MedioPagos>();
  public respuestaF :  any;
  public idCobro: number ;
  private flagFacturacionActiva: boolean=true;
  //VARIABLE PARA OBTENER LA FECHA DE VIGENCIA DEL TRAMITE
  public vigenciaTramite: Date;

  display1: boolean = false;
  showDialog1() {
    this.display1 = true;

  }

  display: boolean = false;
  showDialog() {
    this.display = true;
  }

  enviaC: boolean = false;
  handleChange(e) {
    this.enviaC = e.checked;
  }

  public progressBar = false;
  showBar() {
    this.progressBar = true;
  }

  errorTimbre : boolean = false; 
  showErrorTimbre(){
    this.errorTimbre = true;
  }

  @Output("medioPagosOutput") medioPagosOutput: EventEmitter<MedioPagos>;
  @ViewChild(BuscaDetalleSolicitudComponent, { static: false }) childBuscaDetalleSolicitudes;
  @ViewChild(MedioPagosComponent, { static: false }) childMedioPagos;
  @ViewChild(SolicitudDetallesGridComponent, { static: false }) childSolicitudDetalles;
  @ViewChild(CatCfdiUsosGridComponent, { static: false }) childCatCfdiUsos;
   @ViewChild(DatosFacturacionCajaComponent, { static: false }) childDatosFacturacionCaja;

  public medioPagoLimpio: MedioPagos;

  json_in: json_in;
  catalogosForm: FormGroup;
  cajaServiciosForm: FormGroup;
  mensajeForm: FormGroup;
  muestraMensaje = new MuestraMensaje();
  catMedioPagos: CatMedioPagos[] = [];
  catUsoCfdi: CatCfdiUsos[] = [];
  mediopago = new CatMedioPagos();
  usoCFDI = new CatCfdiUsos();
  public auxJasper: AuxJasper;
  private _jasperService: JasperService;
  serviciosConsultasInput: ServiciosConsultasInput;
  serviciosConsultas: ServiciosConsultas[];
  serviciosCalculos: ServiciosCalculos[];
  busqueda: BuscaTramite;

  solicitud: Solicitudes;
  conRedondeo: boolean = true;

  constructor(

    private registraPagosService: RegistraPagosService,
    private formBuilder: FormBuilder,
    private buscaDetalleSolicitudService: BuscaDetalleSolicitudService,
    private catCfdiUsosService: CatCfdiUsosService,
    private catMedioPagosService: CatMedioPagosService,
    private datosCfdiFacturasService: DatosCfdiFacturasService,
    private personaClientesService: PersonaClientesService,
    private jasp: JasperService,
    private serviciosConsultasService: ServiciosConsultasService,
    private router: Router,
    private solicitudService: SolicitudesService,
    private confirmationService: ConfirmationService,
    private ticketService: TicketService,
    private enviarCorreoService: EnviarCorreoService,
  ) {
    this.usuario = JSON.parse(localStorage.getItem('currentUser'));
    // console.log('usuario', this.usuario.id);
    this._jasperService = jasp;
    this.medioPagosOutput = new EventEmitter()
  }

  ngOnInit() {
    this.getAllCatMedioPagos();
    this.getAllCfdiUsos();
    this.CajaForm = this.formBuilder.group({
      observaciones: [undefined],
      total: [0],
      restante: [0],
      cambio: [0],
      pagado: [0],
    });
    this.totalMedio = 0;
    this.catalogosForm = this.formBuilder.group({
      id: [undefined],
      idMedioPago: [undefined],
    

    });
    this.mensajeForm = this.formBuilder.group({
      mensaje_: [undefined],
    });
    // if (this.solicitudInput) {
    //   this.childBuscaDetalleSolicitud(this.solicitudInput);
    // }
    /* Servicios seleccionados por defecto  */
    this.catalogosForm.patchValue({
      idMedioPago: 1
         
    });
    this.catalogosForm.patchValue({
      id: 3
     
    });
  }
  ngOnChanges() {
    if (this.solicitudInput) {
      this.childBuscaDetalleSolicitud(this.solicitudInput);
      this.PropietarioAguas = null;
    }
  }

  async childBuscaDetalleSolicitud(buscaDetalleSolicitud: BuscaTramite) {

     this.vigenciaTramite = buscaDetalleSolicitud.fechaVigencia;

    this.busqueda = buscaDetalleSolicitud;
    this.idAgua = buscaDetalleSolicitud.idAgua;

    this.enviaCorreo.correo = buscaDetalleSolicitud.emailSolicitante;
    this.personaCliente.id = buscaDetalleSolicitud.idPcSolicitante;

    //if(this.idAguaSolicitante == null) await this.buscaSolicitante();

    await this.mediosPagoInput$.emit(null);
    const infoTramite = new InfoTramiteInput();
    infoTramite.idSolicitud = buscaDetalleSolicitud.id;
    await this.infoTramiteInput$.emit(infoTramite);

    // Carga detalle adeudos
    const buscaDetalleSolicitudInput = new BuscaDetalleSolicitudInput();
    buscaDetalleSolicitudInput.id = buscaDetalleSolicitud.id;
    if(buscaDetalleSolicitudInput.id != 0){
      await this.buscaDetalleSolicitudInput$.emit(buscaDetalleSolicitudInput);
    }else
    {
      await this.buscaDetalleSolicitudInput$.emit(null);
    }

    this.listoPagar = false;
    if(buscaDetalleSolicitud.idEstatus == 3)
    {
      this.pago = true;
      this.listoPagar = true;
    }else if(buscaDetalleSolicitud.idEstatus == 2)
    {
      this.muestraMensaje.notification('Este servicio ya se encuentra Pagado.', 'top', 'center');
      this.listoPagar = false;
    }


    this.CajaForm.patchValue({
      restante: 0,
      cambio: 0,
      pagado: 0
    });

    await this.medioP$.emit(null);
    if(buscaDetalleSolicitudInput.id != 0){
      // console.log("Calcula: ");
      this.getAllServiciosConsultas(buscaDetalleSolicitudInput.id);
    }
    
    this.childMedioPagos.limpiaGrid();
    
    this.idAguaSolicitante = null;
  }

  async getAllCfdiUsosByRegimen() 
  {
    try 
    {
      if(this.personaCliente)
      {
        
        const datoRetorno = await this.catCfdiUsosService.getByRegimen((this.personaCliente.idRegimenFiscal?this.personaCliente.idRegimenFiscal : 12)).toPromise();
        if(datoRetorno)
        {
          this.catUsoCfdi = null;
          this.catUsoCfdi = datoRetorno;
          // ASIGNA EL PRIMER CFDI
          debugger;
          this.catalogosForm.controls['id'].setValue(null);
          this.usoCfdi = null
          if(this.personaCliente?.idUsoCfdi)
            this.usoCFDI = this.catUsoCfdi.find(x => x.id === this.personaCliente.idUsoCfdi); 
          else
            this.usoCFDI = this.catUsoCfdi.find(x => x.id === 22);
          this.catalogosForm.patchValue({
            id: this.usoCFDI.id
            
          });
        }
      }
    } catch (e) {
      if (e.response) {
        throw { message: e.response.data };
      } else {
        throw e;
      }
    } finally {
      console.log("Paso por getCatUsoCfdi");
    }
  }

  // prettier-ignore
  async getBusquedaDetalleSolicitudTotal(buscaDetalleSolicitudInput: BuscaDetalleSolicitudInput) {
    try {
      // console.log('Busqueda: ', buscaDetalleSolicitudInput);
      const datoRetorno1 = await this.buscaDetalleSolicitudService.getBusquedas(buscaDetalleSolicitudInput).toPromise();
      // console.log('Detalle Total: ', datoRetorno1[0]);

      if (datoRetorno1[0].total) {
        this.total = datoRetorno1[0].total;
        //this.CajaForm.patchValue({ total: Math.round(this.total) });
        this.CajaForm.patchValue({ total: this.total });
      } else {
        this.CajaForm.patchValue({ total: 0 });
      }

    } catch (e) {
      if (e.response) { throw { message: e.response.data }; } else { throw e; }
    } finally {
      console.log('Paso por getBusquedas');
    }
  }

  // prettier-ignore
  async getAllServiciosConsultas(idSolicitud: number) {
    try {
      this.serviciosConsultasInput = new ServiciosConsultasInput();
      this.serviciosConsultasInput.idSolicitud = idSolicitud;
      const datoRetorno = await this.serviciosConsultasService.getBusquedas(this.serviciosConsultasInput).toPromise();
      this.serviciosConsultas = datoRetorno;

      this.CalculaTotales();

    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por ignore");
    }
  }

  CalculaTotales() {
    this.serviciosCalculosTotales = new ServiciosCalculosTotales();
    //this.serviciosCalculosTotales.monto = 0;

    for (var i = 0, len = this.serviciosConsultas.length; i < len; ++i) {
      this.serviciosCalculosTotales.monto = this.serviciosCalculosTotales.monto + this.serviciosConsultas[i].monto;
    }

    // console.log('Total Precio: ',this.serviciosCalculosTotales.monto);
    if(this.conRedondeo){
      this.CajaForm.patchValue({total:  Math.ceil(this.serviciosCalculosTotales.monto)});
      this.total = Math.ceil(this.serviciosCalculosTotales.monto);
    }else{
      this.CajaForm.patchValue({total: this.serviciosCalculosTotales.monto});
      this.total = this.serviciosCalculosTotales.monto;
    }

    const medioP = new MedioPagos();
    medioP.monto       = this.total;
    // console.log("Total a Emitir? ", medioP);
    this.medioP$.emit(medioP);
  }

 
 async childMediosPagos(medioPago: MedioPagos) 
 {
    try
    {
      var restante = 0;
      var cambio = 0;

      // SI EL MONTO RECIBIDO ES MENOR DE 0, SE REALIZA UNA SUMA DE TODOS LOS MONTOS EN EL GRID
      if(medioPago.monto < 0)
      {
        this.totalMedio = 0;
        for (var i = 0; i < this.childMedioPagos.MedioPagosTable.length; i++) 
        {
          this.totalMedio = this.totalMedio +  this.childMedioPagos.MedioPagosTable[i].monto;
        }
        // SI EL MONTO RECIBIDO ES IGUAL A 0, EL TOTAL ES 0
      }else if(medioPago.monto == 0)
      {
        this.totalMedio = 0;
      }
      else{
        // SI NINGUNA CONDICION SE CUMPLE ACUMULA LOS MONTOS INGRESADOS
        this.totalMedio = this.totalMedio + medioPago.monto;
      }
      // MUESTRA EN PANTALLA EL ULTIMO MEDIO DE PAGO INGRESADO
      await this.catalogosForm.patchValue({
        idMedioPago: medioPago.idMedioPago,
      });

      await this.selectOPtionA();
      
      if (this.total > this.totalMedio) {
        restante = this.total - this.totalMedio;
      } else {
        cambio = this.totalMedio - this.total;
      }

      this.CajaForm.patchValue({
        restante: restante,
        cambio: cambio,
        pagado: this.totalMedio,
      });
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      console.log("Paso por childTotal");
    }
  }

  getCurrentDateInApiFormat(currentDate): string
  {
    
    let day:any = currentDate.getDate();
    let month:any = currentDate.getMonth() + 1;
    let year:any = currentDate.getFullYear();
    let dateInApiFormat: string;
    
    if(day<10){
      day = "0" + day.toString();
    }
    if(month<10){
      month = "0" + month.toString();
    }
    dateInApiFormat = year.toString() + "-" + month + "-" + day;
    return dateInApiFormat;
  }

  // prettier-ignore
  async Pagar() {
    try 
    {
      
      //SE VALIDAN LA FECHA DE VIGENCIA DEL TRAMITE CONTRA LA FECHA ACTUAL
      if(this.vigenciaTramite){
        let fechaVigenciaString = this.vigenciaTramite.toString().substring(0,10);
        let fechaActualFormateada = new Date();
        let fechaExpira           = new Date(fechaVigenciaString);
        
        let fechaActual   = this.getCurrentDateInApiFormat(fechaActualFormateada);
        let fechaVigencia = this.getCurrentDateInApiFormat(fechaExpira);
        
        if(fechaActual > fechaVigencia)
        {
          //console.log('La vigencia expiro')
          //throw new Error('La vigencia de este trámite ya expiró.');
        }else{
          //console.log('No es mayor');
      }
      }

      this.json_in = new json_in();
      
      //============================================================================
      // Validaciones Cuando No Se Especifica Un Monto de Pago O Metodos De Pago
      //============================================================================
      //if(this.totalMedio < Math.round(this.childSolicitudDetalles.serviciosCalculosTotales.monto) && this.childMedioPagos.MedioPagoTable.length == 0)
      if(this.totalMedio < this.total && this.childMedioPagos.MedioPagoTable.length == 0)
      {
        const medioP = new MedioPagos();
        medioP.idMedioPago = 1;
        medioP.monto       = this.total;
        // console.log("Total Medio a Emitir: ", medioP);
        await this.medioP$.emit(medioP);
        this.json_in.MedioPagos_in.push(medioP);
        debugger;
        await this.catalogosForm.patchValue({idMedioPago: 1,id: 3});
      //}else if (this.totalMedio < Math.round(this.childSolicitudDetalles.serviciosCalculosTotales.monto) && this.childMedioPagos.MedioPagoTable.length > 0) {
      }else if (this.totalMedio < this.total && this.childMedioPagos.MedioPagoTable.length > 0) {
        this.muestraMensaje.error('No has cubierto el total a pagar.', 'top', 'center');
        return;
      }

      if(!this.personaCliente.id && this.flagFacturacionActiva)
        throw new Error('Seleccione un cliente');
      
      if (this.catalogosForm.value.idMedioPago == null || this.catalogosForm.value.id == null) {

        if (this.catalogosForm.value.idMedioPago == null && this.flagFacturacionActiva) {
          this.muestraMensaje.notification('Debe seleccionar un Método de Pago.', 'top', 'center');
        } else if (this.catalogosForm.value.id == null && this.flagFacturacionActiva) {
          this.muestraMensaje.notification('Debe seleccionar el uso del CFDI.', 'top', 'center');
        }
      } else {
        // console.log('LONGITUD TABLA: ', this.childSolicitudDetalles.serviciosConsultas.length);
        for (let i = 0; i < this.childSolicitudDetalles.serviciosConsultas.length; i++) {

          this.buscaDetalleSolicitud = new BuscaDetalleSolicitud()
          this.buscaDetalleSolicitud.idconcepto = this.childSolicitudDetalles.serviciosConsultas[i].idCargo;
          this.json_in.Busca_detalle_solicitud_in.push(this.buscaDetalleSolicitud);
          //this.json_in.Cobros_in.total = Math.round(this.childSolicitudDetalles.serviciosConsultas[i].monto);
          this.json_in.Cobros_in.idSolicitud = this.childSolicitudDetalles.serviciosConsultas[0].idSolicitud;

        }
        this.json_in.Cobros_in.total = this.total;

        //ASIGNA MEDIOS DE PAGO
        for (var i = 0; i < this.childMedioPagos.MedioPagoTable.length; i++) 
        {
          this.medioPagos = new MedioPagos();
          if (this.childMedioPagos.MedioPagoTable[i].idBanco != null){
            this.medioPagos.idBanco = this.childMedioPagos.MedioPagoTable[i].idBanco;
          }
          this.medioPagos.idMedioPago = this.childMedioPagos.MedioPagoTable[i].idMedioPago;
          //this.medioPagos.monto = Math.round(this.childMedioPagos.MedioPagosTable[i].monto);
          this.medioPagos.monto = this.childMedioPagos.MedioPagosTable[i].monto;

          if (this.childMedioPagos.MedioPagoTable[i].autorizacionTarjeta != null){
            this.medioPagos.autorizacionTarjeta = this.childMedioPagos.MedioPagoTable[i].autorizacionTarjeta;
          }
          if (this.childMedioPagos.MedioPagoTable[i].referencia != null)
            this.medioPagos.referencia = this.childMedioPagos.MedioPagoTable[i].referencia;
            this.json_in.MedioPagos_in.push(this.medioPagos);
        }

        const caja = this.CajaForm.value;
        this.json_in.Cobros_in.idAgua = this.idAgua;
        this.json_in.Cobros_in.idUsuarioCobro = this.usuario.id;
        this.json_in.Cobros_in.observaciones = caja.observaciones;
        this.json_in.Cobros_in.conRedondeo = this.conRedondeo;
        this.json_in.Cobros_in.idConceptoGral = 2;

        this.confirmaPago();
      }
    } catch (e) {
      this.muestraMensaje.error(e.message, "bottom", "center");
      if (e.response) { throw { message: e.response.data }; } else { throw e; }
    } finally {
      console.log('Paso por getRAguasPersonas');
      this.progressBar = false;
    }
  }

  async childPersonaClientes(personaClientes: PersonaClientes) 
  {
    const datosFacturacionCaja = new DatosFacturacionCaja();
    datosFacturacionCaja.emailSolicitante = personaClientes.correoElectronico;
    this.enviaCorreo.correo = personaClientes.correoElectronico;
    if (personaClientes.nombre != null) {
      datosFacturacionCaja.solicitante = personaClientes.nombre + ' ' +
        personaClientes.primerApellido + ' ' +
        personaClientes.segundoApellido;
    } else {
      datosFacturacionCaja.solicitante = personaClientes.razonSocial;
    }
    if (personaClientes.rfc != null || personaClientes.rfc === ' ') {
      datosFacturacionCaja.rfcSolicitante = personaClientes.rfc;
    } else {
      datosFacturacionCaja.rfcSolicitante = 'XAXX010101000';
    }
    if( datosFacturacionCaja.rfcSolicitante=="XAXX010101000"){
      this.personaCliente.idRegimenFiscal=12;
      datosFacturacionCaja.idRegimenFiscal=12;
    }
    await this.datosFacturacionCaja$.emit(datosFacturacionCaja);
    this.datosFacturacion = datosFacturacionCaja;
    this.personaCliente = personaClientes;
    this.PropietarioAguas = null;
    
    await this.getAllCfdiUsosByRegimen();
  }

  async selectOPtionA() {
    const idMedioPago = this.catalogosForm.controls.idMedioPago.value;
    this.mediopago = this.catMedioPagos.find(x => x.id === idMedioPago);
  }

  async selectOptionB() {
    debugger;
    const id = this.catalogosForm.controls.id.value;
    this.usoCFDI = this.catUsoCfdi.find(x => x.id === id);
  
  }

  async getAllCatMedioPagos() {
    try {
      const datoRetorno = await this.catMedioPagosService.getAll().toPromise();
      this.catMedioPagos = datoRetorno;
    } catch (e) {
      if (e.response) { throw { message: e.response.data }; } else { throw e; }
    } finally {
      console.log('Paso por getCatMedioPagos', this.catMedioPagos);
    }
  }

  async getAllCfdiUsos() {
    try {
      const datoRetorno = await this.catCfdiUsosService.getAll().toPromise();
      this.catUsoCfdi = datoRetorno;
    } catch (e) {
      if (e.response) { throw { message: e.response.data }; } else { throw e; }
    } finally {
      console.log('Paso por getCatUsoCfdi');
    }
  }


  async Facturar(idcobro) {
    try {
      this.mensajeForm.patchValue({
        mensaje_: 'Realizando facturación, por favor espere...'
      });
      this.showBar();
      debugger;
      this.facturacionData = {
        id: idcobro,
        metodoPago: this.mediopago,
        usoCFDI: this.usoCFDI,
        receptor: this.personaCliente,
      }

       console.log('ESTO SE ENVIA', this.facturacionData)
      const datoretorno = await this.datosCfdiFacturasService
        .add(this.facturacionData)
        .toPromise();
      // console.log('Esto retorna api facturacion---->', datoretorno);
      if (datoretorno) {
        this.progressBar = false;
        this.respuestaF = datoretorno;

        if(this.respuestaF.estatus != 'OK') {
          this.mensajeForm.patchValue({
            mensaje_: this.respuestaF.estatus +'\n \n \n ¿INTENTAR TIMBRAR EL PAGO DE NUEVO?'
          });
          this.showErrorTimbre();
        } else {

          this._id_factura = this.respuestaF.idFactura;
          this.enviaCorreo.idFactura = this._id_factura;
          await this.enviarCorreo();

          await this.imprimeComprobante(
            this.respuestaF.idFactura,
            this.respuestaF.tipoRecibo
          );
        }
      }
    } catch (e) {
      console.log("Error en Facturar", e);
      this.progressBar = false;
      this.mensajeForm.patchValue({
          mensaje_: "EXISTE UN ERROR "+ '\n \n \n ¿INTENTAR TIMBRAR EL PAGO DE NUEVO?'
      });
      this.showErrorTimbre();


    
    } finally {
      this.progressBar = false;
      console.log('Paso por Facturar');
    }
  }

  async buscaSolicitante() {
    try {
      await this.datosFacturacionCaja$.emit();
      this.personaCliente = new PersonaClientes();
     

      let datoretorno = new PersonaClientes();

      if(this.idAguaSolicitante != null) datoretorno = await this.personaClientesService.getSingleAgua(this.idAguaSolicitante).toPromise();
   
   
      if( this.idAguaSolicitante == null || datoretorno==null) datoretorno = await this.personaClientesService.getSingle(1) .toPromise(); 


        if (datoretorno) {
          //  console.log('PERSONA?: ', datoretorno);
          let persona = datoretorno;
          // Carga Datos-FacturaciónCaja Con Persona
          const datosFacturacionCaja = new DatosFacturacionCaja();
  
          datosFacturacionCaja.emailSolicitante = datoretorno.correoElectronico;
          this.personaCliente.id = datoretorno.id;
  
          if (datoretorno.nombre != null && datoretorno.nombre.trim() != "") {
            datosFacturacionCaja.solicitante = datoretorno.nombre;
            this.personaCliente.nombre = datoretorno.nombre;
            if (datoretorno.primerApellido != null && datoretorno.primerApellido.trim() != "") {
              datosFacturacionCaja.solicitante +=
                " " + datoretorno.primerApellido;
              this.personaCliente.primerApellido = datoretorno.primerApellido;
            }
            if (datoretorno.segundoApellido != null && datoretorno.segundoApellido.trim() != "") {
              datosFacturacionCaja.solicitante +=
                " " + datoretorno.segundoApellido;
              this.personaCliente.segundoApellido = datoretorno.segundoApellido;
            }
          } else if (datoretorno.razonSocial != null && datoretorno.razonSocial.trim() != "") {
            datosFacturacionCaja.solicitante = datoretorno.razonSocial;
            this.personaCliente.razonSocial = datoretorno.razonSocial;
          }
          if (datoretorno.rfc != null) {
            datosFacturacionCaja.rfcSolicitante = datoretorno.rfc;
            this.personaCliente.rfc = datoretorno.rfc;
          } else {
            datosFacturacionCaja.rfcSolicitante = "XAXX010101000";
            this.personaCliente.rfc = "XAXX010101000";
          }
          if(datoretorno.idRegimenFiscal != null){
            datosFacturacionCaja.idRegimenFiscal = datoretorno.idRegimenFiscal;
            this.personaCliente.idRegimenFiscal  = datoretorno.idRegimenFiscal;
          }
          if(datoretorno.cp != null){
            datosFacturacionCaja.cp = datoretorno.cp;
            this.personaCliente.cp = datoretorno.cp;
          }
  
          await this.datosFacturacionCaja$.emit(datosFacturacionCaja);
          this.datosFacturacion = datosFacturacionCaja;
          
          await this.getAllCfdiUsosByRegimen();
         
        }
    } catch (e) {
      if (e.response) { throw { message: e.response.data }; } else { throw e; }
    } finally {
      console.log('Paso por buscaSolicitante');
    }
  }

  async imprimeComprobante(id_Factura, reporte) {
    try {

      this.auxJasper = new AuxJasper();
      this.auxJasper.JasperReport.tipo = 'pdf';
      // if (reporte === 1) {
        this.auxJasper.JasperReport.nombreReporte = '001_Factura';
      // } else if (reporte === 2) {
      //   this.auxJasper.JasperReport.nombreReporte = '002_RecibosinTimbre';
      // }
      // console.log('Tipo de Comprobante: ', reporte);
      // -- Parametros --
      const id_factura = new ParametroJasper();
      id_factura.nombre = '_id_factura';
      id_factura.valor = id_Factura + '';
      let reimpresion = new ParametroJasper();
      reimpresion.nombre = 'reimpresion';
      reimpresion.valor = false + "";
      let timbre = new ParametroJasper();
      timbre.nombre = 'timbre';
      const withCopy = new ParametroJasper();
      withCopy.nombre = 'withCopy';
      withCopy.valor = 'wCopy';

      debugger;
      if (reporte === 1) 
          timbre.valor = true + "";
      else
          timbre.valor = false + "";
      
      await this.auxJasper.ParametroJasper.push(reimpresion);
      await this.auxJasper.ParametroJasper.push(timbre);
      // console.log('Parametro:', id_factura.nombre, 'Valor:', id_factura.valor);

      await this.auxJasper.ParametroJasper.push(id_factura);
      await this.auxJasper.ParametroJasper.push(withCopy);
      // console.log('Agui va', this.auxJasper);

      await this.showDialog();

    } catch (e) {
      if (e.response) { throw { message: e.response.data }; } else { throw e; }
    } finally {
      console.log('Paso por imprimeComprobante');
    }
  }

  async enviarCorreo() {
    try {
      
      const datosenviarCorreo = new EnviarCorreo();
      let DatoCorreo = this.childDatosFacturacionCaja.datosFiscalesForm.get('email').value;
      datosenviarCorreo.idFactura = this._id_factura;
      datosenviarCorreo.enviosFactura = true;
      datosenviarCorreo.correo = DatoCorreo == undefined ? "" : DatoCorreo;
      datosenviarCorreo.correocopia = "";
   
     //validamos si existe un correo enviara la factura
      if (datosenviarCorreo.correo != null && datosenviarCorreo.correo != "" && datosenviarCorreo.correo != undefined) {

        this.mensajeForm.patchValue({
          mensaje_: 'Eviando factura por correo, por favor espere...'
        });

        this.progressBar = true; 
        const datoretorno = await this.enviarCorreoService.add(datosenviarCorreo).toPromise();
        let respuesta = datoretorno;
        
        if (respuesta.toString() == "OK") { 
            this.progressBar = false;
            this.muestraMensaje.notification("Envió de factura por correo exitoso", "top", "center");
        }
        else {
          this.muestraMensaje.error("No fue posible enviar la factura por correo", "top", "center")
        }
      }
      await this.datosenviarCorreo$.emit(datosenviarCorreo); // ese emite para mostrar el envio de correo de forma manual
    } catch (e) {
      console.log("Error en enviarCorreo", e);
    } finally {
      console.log("Paso por enviarCorreo");
    }
  }
  
  async confirmaPago() 
  {
    try 
    {
      //=================================================================================
      // Ventana de confirmación Pago
      //=================================================================================
      var metodosPagos = "";
      var metodoItem   = new CatMedioPagos();
      var monto = 0;
    
      this.json_in.MedioPagos_in.forEach(element => 
      {
        metodoItem = this.catMedioPagos.find((x) => x.id === element.idMedioPago);
        monto = monto + element.monto;
        metodosPagos = metodosPagos + metodoItem.descripcion + ", "
      });
  
      if(metodosPagos.length > 0) metodosPagos = metodosPagos.substring(0, metodosPagos.length - 2);
     /* if(this.PropietarioAguas){
        this.personaCliente = this.PropietarioAguas;
      }*/
  
     
      if(this.personaCliente.id != 1 && !this.personaCliente.cp && this.flagFacturacionActiva)
        throw new Error('Debes de indicar el código postal en los datos de facturación');
  
      if(!this.personaCliente.idRegimenFiscal && this.flagFacturacionActiva)
        throw new Error('El solicitante debe de tener un régimen fiscal específicado');

      if(this.personaCliente.id != 1 && this.personaCliente.rfc == "XAXX010101000" && this.flagFacturacionActiva)
        throw new Error('Debes seleccionar al público general para el uso del rfc genérico');

          await this.confirmationService.confirm({
            message: '<b>Solicitante  :</b> '+(this.personaCliente.nombre == null || this.personaCliente.nombre == '' ? 
            (this.personaCliente.razonSocial === undefined ?  " " : this.personaCliente.razonSocial)   : 
            (this.personaCliente.nombre === undefined ?  " " : this.personaCliente.nombre) + " "+  
            (this.personaCliente.primerApellido === undefined ?  " " : this.personaCliente.primerApellido) + " "+ 
            (this.personaCliente.segundoApellido === undefined ?  " " : this.personaCliente.segundoApellido)
            )+"<br>"
                  // + '<b>RFC: </b>    '+ this.personaCliente.rfc +"<br>"
                  + '<b>Medio de Pago: </b>'+ metodosPagos+"<br>"
                  + '<b>Total:</b> $'+ monto,
            accept: () => 
            {
              this.mensajeForm.patchValue({
                mensaje_: 'Realizando pago, por favor espere...'
              });
              this.showBar();
  
              this.RealizaPago();
            },
            reject: () => {
              return;
            },header:"Confirmación de Pago"
            ,acceptLabel:"Si"
            ,defaultFocus:"5px"
        });
      }catch(e)
      {
        this.muestraMensaje.error(e.message, "bottom", "center");
        if (e.response) { throw { message: e.response.data }; } else { throw e; }
      }

    }
  

  async RealizaPago()
  {
    try{
      this.mensajeForm.patchValue({
        mensaje_: 'Realizando pago, por favor espere...'
      });
      this.showBar();

      const datoRetorno = await this.registraPagosService
        .getBusquedas(this.json_in)
        .toPromise();
  
      // =========================================================
      //                    FACTURAR
      // =========================================================
  
      // console.log('ESTO RETORNA', datoRetorno)
      if ( datoRetorno[0].idCobro) {
        this.progressBar = false;
        this.idCobro= datoRetorno[0].idCobro;

        if(this.flagFacturacionActiva)
            await this.Facturar(this.idCobro);
        else 
            this.generateTicket(this.idCobro);
      } else if (!datoRetorno[0].idCobro) {
        let errorP = datoRetorno.toString();
        throw new Error(errorP);
      }
       
      
      this.CajaForm.patchValue({
        restante: 0,
        cambio: 0,
        total: 0,
        observaciones: '',
        pagado: 0
      });
      this.totalMedio = 0;
      // =========================================================
  
      // PROCESO DESPUES DEL PAGO --LIMPIA DE LOS COMPONENTES
      this.muestraMensaje.notification('Proceso Concluido.', 'top', 'center');
  
      this.listoPagar = true;
      
      let solicitudes = new BuscaTramite;
      solicitudes.numSolicitud = 0;
      solicitudes.id = 0;
      solicitudes.idPcSolicitante = 0;
      this.childBuscaDetalleSolicitud(solicitudes);
    }catch(e)
    {
      this.muestraMensaje.error(e.message, "bottom", "center");
      if (e.response) { throw { message: e.response.data }; } else { throw e; }
    }finally
    {
      this.progressBar = false;
    }
    
  }

  async  generateTicket(idCobro: number) {
    
      // get coded string 

      const ticketContent = await  this.ticketService.getCryptedTicket(idCobro).toPromise();
    // Crear un nuevo Blob con el contenido del ticket
    const blob = new Blob([ticketContent], { type: 'text/plain;charset=utf-8' });
  
    // Guardar el archivo en una carpeta específica con el nombre "ticket.txt"
    saveAs(blob, '6e8788b6-d7cb-4961-adc0-0c3fa525924b.dat');
  }


  async confirm() { 
    this.errorTimbre  = false;
    await this.Facturar(this.idCobro);
  }

  async cancelar() {
    this.errorTimbre  = false;

    if(this.respuestaF==null || this.respuestaF==undefined){
      this.respuestaF = {
          idFactura: this.facturacionData.id,
          tipoRecibo: 2,
          estatus: ""
        };
      
  }
      
    await this.imprimeComprobante(
      this.respuestaF.idFactura,
      this.respuestaF.tipoRecibo
    );
  }

  async RecivePropietario(event: {propietario: any, idAgua: number}){
    
    this.PropietarioAguas = event.propietario;
    this.idAguaSolicitante = event.idAgua;
    await this.buscaSolicitante();
    this.idAguaSolicitante = null;
  }

  onCheckboxChange(event: any) {
    debugger;
    this.conRedondeo =event.checked;
    this.CalculaTotales();

    let cambio = 0;
    if (this.totalMedio > this.total) {
      cambio = this.totalMedio - this.total;
    }
    this.CajaForm.patchValue({
      cambio: cambio
    });

  } 
}
